import { encode, decode } from 'js-base64'
import { useCookies } from 'react-cookie'

const COOKIE_EMAIL = 'ttz.ra-auth.e'
const COOKIE_PASSWORD = 'ttz.ra-auth.p'
const COOKIE_OPTIONS = { path: '/' }

type AuthCookies = {
  getEmail: () => string
  getPassword: () => string
  setEmail: (email: string) => void
  setPassword: (pwd: string) => void
  clearEmail: () => void
  clearPassword: () => void
  clearAll: () => void
}

export const useAuthCookies = (): AuthCookies => {
  const [cookies, setCookie, removeCookie] = useCookies([
    COOKIE_EMAIL,
    COOKIE_PASSWORD
  ])

  const getEmail = () => cookies[COOKIE_EMAIL] || ''
  const getPassword = () => {
    try {
      return cookies[COOKIE_PASSWORD] ? decode(cookies[COOKIE_PASSWORD]) : ''
    } catch {
      return ''
    }
  }

  const setEmail = (email: string) =>
    setCookie(COOKIE_EMAIL, email, COOKIE_OPTIONS)
  const setPassword = (pwd: string) =>
    setCookie(COOKIE_PASSWORD, encode(pwd), COOKIE_OPTIONS)
  const clearEmail = () => removeCookie(COOKIE_EMAIL, COOKIE_OPTIONS)
  const clearPassword = () => removeCookie(COOKIE_PASSWORD, COOKIE_OPTIONS)

  const clearAll = () => {
    clearEmail()
    clearPassword()
  }

  return {
    getEmail,
    getPassword,
    setEmail,
    setPassword,
    clearEmail,
    clearPassword,
    clearAll
  }
}
